module.exports = __webpack_public_path__ + "img/pikantesuppemithintergrund.ff547d30.jpg";